module.exports = __webpack_public_path__ + "img/bg_6.bc4e686d.png";